import get from 'lodash/get';

import {
  getIsBrokerAccount,
} from './user.path';

export const PLAN_TYPE__FREE = 'free';
export const PLAN_TYPE__DEALER = 'dealer';
export const PLAN_TYPE__DEALER_PRO = 'dealer_pro';
export const PLAN_NAME = {
  [PLAN_TYPE__FREE]: 'Free',
  [PLAN_TYPE__DEALER]: 'Dealer',
  [PLAN_TYPE__DEALER_PRO]: 'Dealer Pro',
};

const defaultSubscriptionEntitlements = {
  planType: 'free',
  'analytics-views': true,
  'analytics-calls': false,
  'analytics-saves': true,
  'analytics-messages': false,
  'aircraft-for-sale-labs': false,
  'afs-print-listings': true,
  'featured-listing': 0,
  'aircraft-listings': 1,
  seats: 0,
};

const defaultUserProperties = {
  listings: 0,
  brokers: 0,
};

const defaultUserLimits = {
  canCreateAirListing: false,
  canCreateREListing: false,
  canInviteBroker: false,
};

export const defaultSubscriptionInfo = {
  entitlements: defaultSubscriptionEntitlements,
  properties: defaultUserProperties,
  limits: defaultUserLimits,
};

export const getIsShowManageTeamNav = (user, subscriptionEntitlements) => {
  const isDealerSubscription = getIsDealerSubscription(subscriptionEntitlements);
  const isDealerProSubscription = getIsDealerProSubscription(subscriptionEntitlements);
  const isBrokerAccount = getIsBrokerAccount(user);
  return (isDealerSubscription || isDealerProSubscription) && !isBrokerAccount;
};

export const getIsAllowDashboard = entitlements => {
  return getIsDealerSubscription(entitlements)
    || getIsDealerProSubscription(entitlements)
  ;
};

export const getIsFreeSubscription = entitlements => {
  return [PLAN_TYPE__FREE].includes(entitlements.planType);
};

export const getIsDealerSubscription = entitlements => {
  return [PLAN_TYPE__DEALER].includes(entitlements.planType);
};

export const getIsDealerProSubscription = entitlements => {
  return [PLAN_TYPE__DEALER_PRO].includes(entitlements.planType);
};

export const isNotFreeSubscription = entitlements => {
  return [PLAN_TYPE__DEALER, PLAN_TYPE__DEALER_PRO].includes(entitlements.planType);
};

export const getIsShowBrokerField = entitlements => {
  return isNotFreeSubscription(entitlements);
};

export const getRemainingFeaturedListings = subscriptionInfo => {
  const planFeaturedCount = get(subscriptionInfo, 'entitlements.featured-listing', 0);
  const actualFeaturedCount = get(subscriptionInfo, 'properties.airPlanFeaturedListings', 0);
  return planFeaturedCount - actualFeaturedCount;
};

export const getCanSetAirPlanFeaturedListing = subscriptionInfo => {
  return get(subscriptionInfo, 'limits.canSetAirPlanFeaturedListing', false);
};

export const getIsUnlimitedSeats = subscriptionInfo => {
  return getIsDealerProSubscription(subscriptionInfo.entitlements);
};

export const getShowUnlimitedAircraftListingsBlock = entitlements => {
  return getIsDealerProSubscription(entitlements);
};
